module.exports = __webpack_public_path__ + "static/media/features-split-top-04.ade5421b.png";